import { useEffect, useRef } from 'react';
import L from 'leaflet';
import { useTheme } from 'styled-components';
import { useMapInstance } from './LeafletMap';

export const PlacesLayer = ({ places, onMarkerClick }) => {
  const map = useMapInstance();
  const markersRef = useRef([]);
  const { colors } = useTheme();

  useEffect(() => {
    if (!map || !places) return;

    markersRef.current.forEach(m => m.remove());
    markersRef.current = [];

    const color = colors('link');
    const icon = L.divIcon({
      html: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <circle cx="16" cy="16" r="10" fill="${color}" />
        <circle cx="16" cy="16" r="6" fill="white" fill-opacity="0.4" />
      </svg>`,
      className: '',
      iconSize: [32, 32],
      iconAnchor: [16, 16],
    });

    places.forEach(place => {
      const lat = parseFloat(place.latitude);
      const lng = parseFloat(place.longitude);
      if (isNaN(lat) || isNaN(lng)) return;
      const marker = L.marker([lat, lng], { icon })
        .addTo(map)
        .on('click', () => {
          map.panTo([lat, lng]);
          onMarkerClick?.(place);
        });
      markersRef.current.push(marker);
    });

    return () => {
      markersRef.current.forEach(m => m.remove());
      markersRef.current = [];
    };
  }, [map, places]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};
